import { useEffect, useState } from "react";
import { unparse } from "papaparse";

export default function useStringifyCSV(data){
    const [parsed, setParsed] = useState(null);
    
    useEffect(()=>{
        if(data){
            setParsed(unparse(data));
            return 
        }else if(parsed){
            setParsed(null);
        }
    },[data]);

    return parsed;
}